import type { ListAllTryReservationsFilters } from './filters';

const reservationsBase = ['try-reservations'] as const;
export const tryReservationsKeys = {
  details: () => [...reservationsBase, 'detail'] as const,
  detail: (id: string) => [...tryReservationsKeys.details(), id] as const,
  active: () => [...reservationsBase, 'active'] as const,
  allMachines: () => [...reservationsBase, 'machines'],
  machines: (orgId: string) => [
    ...tryReservationsKeys.allMachines(),
    { orgId },
  ],
};

const agentsBase = ['try-agents'] as const;
export const tryAgentsKeys = {
  lists: () => [...agentsBase, 'list'] as const,
};

const adminBase = ['try-admin'] as const;
export const tryAdminKeys = {
  counts: () => [...adminBase, 'counts'] as const,
  lists: () => [...adminBase, 'list'] as const,
  list: (query: ListAllTryReservationsFilters) =>
    [...tryAdminKeys.lists(), query] as const,
};
